document.addEventListener('DOMContentLoaded', () => {
	const lightbox = GLightbox({
		selector: '.glightbox',
		touchNavigation: true,
		loop: true,
		zoomable: false,
		draggable: true,
	});
});